import { render, staticRenderFns } from "./ResultPatientsListItem.vue?vue&type=template&id=3884ebc1&scoped=true&"
import script from "./ResultPatientsListItem.vue?vue&type=script&lang=js&"
export * from "./ResultPatientsListItem.vue?vue&type=script&lang=js&"
import style0 from "./ResultPatientsListItem.vue?vue&type=style&index=0&id=3884ebc1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3884ebc1",
  null
  
)

export default component.exports